import { render, staticRenderFns } from "./billedVsRealFilterable.vue?vue&type=template&id=602d514a&scoped=true"
import script from "./billedVsRealFilterable.vue?vue&type=script&lang=js"
export * from "./billedVsRealFilterable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602d514a",
  null
  
)

export default component.exports